import { css, Paragraph, styled } from 'canoe';
import React from 'react';

interface Props {
  minWidth?: number;
  labelContent?: string;
  placeholderText?: string;
}

const DashedOutline = styled.div<{ content?: string; minWidth?: number }>`
  ${({ theme, content, minWidth }) => css`
    display: flex;
    flex-grow: 1;
    min-height: 100%;
    min-width: 100%;
    align-items: center;
    justify-content: center;
    border: 2px dashed ${theme.colors.border};
    padding: 20px;
    width: 100%;
    min-width: 120px;
    user-select: none;

    background-color: ${theme.colors.White};

    ${minWidth &&
    css`
      min-width: ${minWidth}px;
    `}

    ${content &&
    css`
      position: relative;
      background-color: ${theme.colors.GlitterGrayL20};

      & > div {
        background-color: ${theme.colors.White};
        width: 100%;
        position: relative;
        overflow: hidden;
      }
    `}
  `}
`;

const LabelContent = styled.span`
  ${({ theme }) => css`
    display: block;
    font-size: ${theme.fonts.small.fontSize};
    color: ${theme.colors.OnyxGrayL30};
    position: absolute;
    top: 0;
    left: ${theme.spaces.xxs};
  `}
`;

const PlaceholderText = styled(Paragraph)`
  ${({ theme }) => css`
    line-height: 18px;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: auto;
    font-size: ${theme.fonts.small.fontSize};
    color: ${theme.colors.OnyxGrayL30};
    padding: ${theme.spaces.xs};
  `}
`;

const Placeholder = ({ minWidth, labelContent, placeholderText }: Props) => (
  <DashedOutline content={labelContent} minWidth={minWidth} data-cy="placeholder">
    {labelContent && <LabelContent>{labelContent}</LabelContent>}
    <div>
      <PlaceholderText size="short">
        {placeholderText || 'Drag any element into this area.'}
      </PlaceholderText>
    </div>
  </DashedOutline>
);

export default Placeholder;
